import type { Notification, NotificationResult } from './notifications.types';

import type { AnalyticsEvent } from 'src/common/interfaces/segment';

export function categorizeNotifications(notificationsToCategorize?: Notification[]) {
  const specialUserNotifications: NotificationResult[] = [];
  const userNotifications: NotificationResult[] = [];

  if (notificationsToCategorize) {
    for (const notification of notificationsToCategorize) {
      if (notification?.isSpecial) specialUserNotifications.push(notification);
      if (notification && !notification.isSpecial) userNotifications.push(notification);
    }
  }

  return { specialUserNotifications, userNotifications };
}

type TrackedNotification = NotificationResult & {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onView?: () => void;
};

export function addTrackingToNotifications(
  notifications: NotificationResult[],
  trackEvent: (event: AnalyticsEvent) => void,
): TrackedNotification[] {
  return notifications.map<TrackedNotification>((notification) => {
    const { groupId } = notification;
    if (!groupId) return notification;
    return {
      ...notification,
      onClick: (e: React.MouseEvent<HTMLDivElement>) => {
        const anchor = (e.target as HTMLElement).closest('a');
        if (!anchor) return;
        trackEvent({
          event: 'click-notification-link',
          properties: { 'group-id': groupId },
        });
      },
      onView: () => {
        trackEvent({
          event: 'view-notification',
          properties: { 'group-id': groupId },
        });
      },
    };
  });
}
